// extracted by mini-css-extract-plugin
module.exports = {"Container":"skeleton_Container__1UWn9","Row":"skeleton_Row__PQtLz","skeleton-loading":"skeleton_skeleton-loading__IUqQL"};